import { Logo } from "./Logo";
import { getOppositeAppUrl } from "../../config/theme";

export const Footer = ({ isProviderApp = false }) => {
  const oppositeAppUrl = getOppositeAppUrl();

  return (
    <footer id="footer">
      <hr className="w-11/12 mx-auto" />

      <section className="container py-20 grid grid-cols-2 md:grid-cols-4 xl:grid-cols-6 gap-x-12 gap-y-8">
        <div className="col-span-full xl:col-span-2">
          <a
            rel="noreferrer noopener"
            href="/"
            className="font-bold text-xl flex font-serif2 items-center"
          >
            <Logo />
          </a>
          <p className="mt-6">
            the easiest way to find and book, reliable, vetted local service
            providers - without any of the hassle
          </p>
        </div>

        <div className="flex flex-col gap-2">
          <h3 className="font-bold text-lg">Follow Us</h3>
          <div>
            <a
              rel="noreferrer noopener"
              href="https://www.instagram.com/"
              target="_blank"
              className="opacity-60 hover:opacity-100"
            >
              Instagram
            </a>
          </div>

          <div>
            <a
              rel="noreferrer noopener"
              href="https://www.twitter.com/"
              target="_blank"
              className="opacity-60 hover:opacity-100"
            >
              Twitter
            </a>
          </div>

          <div>
            <a
              rel="noreferrer noopener"
              href="https://www.facebook.com/"
              target="_blank"
              className="opacity-60 hover:opacity-100"
            >
              Facebook
            </a>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <h3 className="font-bold text-lg">Platform</h3>
          <div>
            <a
              rel="noreferrer noopener"
              href={
                isProviderApp ? oppositeAppUrl : `${oppositeAppUrl}/marketing`
              }
              className="opacity-60 hover:opacity-100"
            >
              {isProviderApp
                ? "Go to Homeowner site"
                : "Become a Service Provider"}
            </a>
          </div>

          {!isProviderApp && (
            <div>
              <a
                rel="noreferrer noopener"
                href="/services"
                className="opacity-60 hover:opacity-100"
              >
                Browse services
              </a>
            </div>
          )}
        </div>

        <div className="flex flex-col gap-2">
          <h3 className="font-bold text-lg">Company</h3>
          <div>
            <a
              rel="noreferrer noopener"
              href="/about"
              className="opacity-60 hover:opacity-100"
            >
              About Us
            </a>
          </div>

          <div>
            <a
              rel="noreferrer noopener"
              href="/careers"
              className="opacity-60 hover:opacity-100"
            >
              Careers
            </a>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <h3 className="font-bold text-lg">Legal</h3>

          <div>
            <a
              rel="noreferrer noopener"
              href="/terms"
              className="opacity-60 hover:opacity-100"
            >
              Terms of Service
            </a>
          </div>

          <div>
            <a
              rel="noreferrer noopener"
              href="/privacy"
              className="opacity-60 hover:opacity-100"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </section>

      <section className="container pb-14 text-center">
        <h3>
          &copy; {new Date().getFullYear()} Mikey, Inc. Made with ❤️ in Calgary.
        </h3>
      </section>
    </footer>
  );
};
